import React from "react";
import {
  FaEnvelopeSquare,
  FaGithubSquare,
  FaLinkedin,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { Typewriter } from "react-simple-typewriter";
import { AboutMe } from "../data/about-me-data";

const contactIconClass =
  "cursor-pointer text-[2rem] text-portfolio-inverse hover:text-portfolio-accent";

export default function AsideProfile() {
  return (
    <div className="relative w-fit max-[1024px]:w-3/4 max-[500px]:w-full">
      <div className="absolute -left-4 -right-4 bottom-8 top-8 z-0 bg-portfolio-accent max-[1024px]:-left-2 max-[1024px]:-right-2" />

      <aside className="relative h-screen w-72 bg-portfolio-surface min-[1400px]:w-[22rem] [@media(max-height:550px)_and_(min-width:1025px)]:h-[700px] [@media(min-height:900px)_and_(min-width:1025px)]:h-[900px] max-[1024px]:h-auto max-[1024px]:w-full">
        <section className="flex h-1/2 w-full items-center justify-center max-[1024px]:py-12">
          <div className="flex h-[calc(12rem_+_var(--my-picture--border-width)_*_4)] w-[calc(12rem_+_var(--my-picture--border-width)_*_4)] items-center justify-center rounded-full border-solid border-portfolio-deepest [border-width:var(--my-picture--border-width)]">
            <img
              className="w-48 select-none rounded-full"
              src={AboutMe.Image}
              alt="Tareq Harh"
              loading="eager"
              fetchPriority="high"
              decoding="async"
            />
          </div>
        </section>

        <section className="flex h-1/2 w-full flex-col items-center justify-center gap-8 bg-portfolio-deepest py-12 [clip-path:polygon(0%_0%,0%_100%,100%_100%,100%_0%,50%_2rem)] max-[1024px]:py-20">
          <div className="flex flex-col items-center gap-2 text-portfolio-inverse">
            <h1 className="text-2xl font-semibold uppercase leading-[1.2em]">
              {AboutMe.FullName}
            </h1>

            <p className="block h-[1.2em] select-none text-base font-medium leading-[1.2em] text-portfolio-accent">
              <Typewriter
                words={AboutMe.JobTitles}
                typeSpeed={80}
                deleteSpeed={60}
                loop={0}
                delaySpeed={2000}
              />
            </p>
          </div>

          <div className="flex gap-1">
            <Link to={AboutMe.LinkedInLink} target="_blank">
              <FaLinkedin className={contactIconClass} />
            </Link>
            <Link to={AboutMe.GitHubLink} target="_blank">
              <FaGithubSquare className={contactIconClass} />
            </Link>
            <Link to={`mailto:${AboutMe.Email}`} target="_blank">
              <FaEnvelopeSquare className={contactIconClass} />
            </Link>
          </div>
        </section>
      </aside>
    </div>
  );
}
